import { styled } from '@f8n-frontend/stitches';
import { GetStaticPropsContext } from 'next';

import { ArticleBlock, ArticleGrid, FeaturedArticle } from 'components/Article';
import Page from 'components/Page';
import Body from 'components/base/Body';
import PreviewModeButton from 'components/homepage/PreviewModeButton';

import { getAllArticles } from 'queries/server/articles';

import { ContentfulArticle } from 'types/Contentful';

type BlogIndexProps = {
  articles: ContentfulArticle[];
  preview: boolean;
};

export default function BlogIndex(props: BlogIndexProps) {
  const { articles, preview } = props;

  const [featuredArticle, ...otherArticles] = articles;

  return (
    <Page title="Blog" type="MAXIMAL" footerMode="LIGHT">
      <PageBody>
        <FeaturedArticleWrapper>
          <FeaturedArticle article={featuredArticle as ContentfulArticle} />
        </FeaturedArticleWrapper>
        <ArticleGrid>
          {otherArticles.map((article) => (
            <ArticleBlock article={article} key={article?.title} />
          ))}
        </ArticleGrid>
      </PageBody>
      <PreviewModeButton isPreviewEnabled={preview} />
    </Page>
  );
}

export async function getStaticProps({
  preview = false,
}: GetStaticPropsContext) {
  const articles = await getAllArticles({ preview });
  return {
    props: {
      articles,
      preview,
    },
    revalidate: 60,
  };
}

const PageBody = styled(Body, {
  paddingY: '$7',
  '@bp0': { paddingY: '$8' },
});

const FeaturedArticleWrapper = styled('div', {
  marginBottom: '$7',
  '@bp2-max': { marginX: 'auto', maxWidth: '600px' },
  '@bp2': { marginBottom: '$8' },
});
